module.exports = `//${location.host}/travel/setup.js/index.jsp?` +
    (location.search ? `&${location.search.slice(1)}` : '');
